import React from 'react';
import {Modal} from "react-bootstrap";
import TableConfigCreateForm from "./TableConfigCreateForm";
import {useDispatch, useSelector} from "react-redux";
import {showCreateModal} from "../../redux-store/selectors";
import {setShowCreateModal} from "../../redux-store/dynamicTable";

function TableConfigCreateModal() {

    const dispatch = useDispatch()
    const show = useSelector(showCreateModal)

    const handleCloseModal = () => {
        dispatch(setShowCreateModal(false))
    }

    return (
        <Modal
            show={show}
            onHide={handleCloseModal}
            backdrop="static"
            keyboard={false}
            className={"antd-modal-table"}
        >
            <Modal.Header>
                <Modal.Title className={"title-confirm"}>Kreator tabele</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={"mb-5 text-left"}>
                    <TableConfigCreateForm/>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default TableConfigCreateModal;
